module.exports = __webpack_public_path__ + "img/icon-hu-line.f6c41a99.svg";